import { useRef, useState } from "react";

// Avvolge un'area che contiene un <input type="file"> (anche nascosto).
// Trascinando dei file sull'area, li assegna all'input e scatena l'onChange esistente,
// oppure, se passato onFiles, invoca direttamente la callback con la FileList.
export function DropZone({ children, onFiles, className = "", disabled = false, label = "Rilascia i file qui…" }) {
  const ref = useRef(null);
  const [over, setOver] = useState(false);
  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOver(false);
    if (disabled) return;
    const files = e.dataTransfer?.files;
    if (!files || files.length === 0) return;
    if (onFiles) { onFiles(files); return; }
    const input = ref.current?.querySelector('input[type="file"]');
    if (input) {
      try { input.files = files; } catch { /* alcuni browser non permettono l'assegnazione */ }
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };
  return (
    <div
      ref={ref}
      onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); if (!disabled) setOver(true); }}
      onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); if (!disabled) setOver(true); }}
      onDragLeave={(e) => { e.preventDefault(); e.stopPropagation(); if (e.currentTarget === e.target) setOver(false); }}
      onDrop={onDrop}
      className={`relative transition-colors ${over ? "ring-2 ring-primary/60 bg-primary/5" : ""} ${className}`}
      data-testid="dropzone"
    >
      {children}
      {over && (
        <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center rounded-sm border-2 border-dashed border-primary/60 bg-background/70 text-sm font-medium text-primary">
          {label}
        </div>
      )}
    </div>
  );
}
